import React from 'react';
const TriangularDot = _ref => {
  let {
    cx,
    cy,
    color
  } = _ref;
  const size = 10;
  return /*#__PURE__*/React.createElement("polygon", {
    points: "".concat(cx - size / 2, ",").concat(cy + size / 2, " ").concat(cx, ",").concat(cy - size / 2, " ").concat(cx + size / 2, ",").concat(cy + size / 2),
    fill: color
  });
};
export default TriangularDot;